// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDAtFwtoIkDgO1D9XfSrshqH6Xk6jQ7OH0",
  authDomain: "zappcan.com",
  projectId: "fruitsell-8cb00",
  storageBucket: "fruitsell-8cb00.firebasestorage.app",
  messagingSenderId: "559157515781",
  appId: "1:559157515781:web:9f77b2f54ddce722b26e6c",
  measurementId: "G-X1G3BBM01V"
};


const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);

